import styled from "styled-components";

export const InputGroup = styled.div`
  margin: 20px 0;

  display: flex;
  flex-direction: column;
  color: #333;

  legend {
    color: #0000ff;
    line-height: 1.75rem;
  }
`;
